/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { ILinksData } from '../ie-promo-banner.props.autogenerated';

export interface IPromoBannerLinks {
    links: ILinksData[];
}

export const PromoBannerLinks: React.FC<IPromoBannerLinks> = ({ links }) => (
    <span className='ms-promo-banner__links'>
        {links.map((link: ILinksData, index: number) => (
            // tslint:disable-next-line:react-a11y-anchors
            <a
                className='ms-promo-banner__link'
                key={index}
                color='link'
                title={link.linkText}
                href={link.linkUrl && link.linkUrl.destinationUrl}
                aria-label={link.ariaLabel}
            >
                {link.linkText}
            </a>
        ))}
    </span>
);